<!-- @TODO calcular paralelamente sobre los drawings existentes (puede que el organizador haya metido nuevos jugadores en la fase de eliminacion). El valor que sea mayor es el que se muestra.) -->

<div class="row">
  <div class="col-md-3">
    <app-lead-conversation
      [numberDrawings]="numberEventsTeams()"
    ></app-lead-conversation>
  </div>
  <div class="col-md-3">
    <app-lead-conversation-2
      [numberGames]="numberGroupsGames() + numberMainDrawsGames() + numberBackDrawsGames()"
      [numberPlayedGames]="numberPlayedGames()"
    ></app-lead-conversation-2>
  </div>
</div>
